module.exports = __webpack_public_path__ + "images/kranken-unfall2.png?76ac9882f85d48994bbae39f801ff347";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kranken-unfall2.png
// module id = Sag2
// module chunks = 0